
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { CalendarIcon, TruckIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';

interface ProcurementDeliveryDetailsProps {
  procurement: any; // Replace with proper type when available
}

export function ProcurementDeliveryDetails({ procurement }: ProcurementDeliveryDetailsProps) {
  const isMobile = useIsMobile();
  
  const getDeliveryStatusIcon = () => {
    if (procurement.delivery_date) {
      return <CheckCircleIcon className="h-5 w-5 text-green-600" />;
    } else {
      return <ClockIcon className="h-5 w-5 text-amber-600" />;
    }
  };
  
  return (
    <div className="space-y-4">
      <div className={isMobile ? "grid grid-cols-1 gap-4" : "grid grid-cols-1 md:grid-cols-2 gap-4"}>
        <div className="p-4 border rounded-md">
          <h3 className="text-sm font-medium mb-2 flex items-center">
            <CalendarIcon className="mr-1 h-4 w-4" />
            Expected Delivery
          </h3>
          <p>Date: {procurement.expected_delivery_date 
            ? new Date(procurement.expected_delivery_date).toLocaleDateString() 
            : 'Not specified'}</p>
        </div>
        
        <div className="p-4 border rounded-md">
          <h3 className="text-sm font-medium mb-2 flex items-center">
            <TruckIcon className="mr-1 h-4 w-4" />
            Actual Delivery
          </h3>
          <div className="flex items-center">
            {getDeliveryStatusIcon()}
            <p className="ml-1">
              {procurement.delivery_date 
                ? new Date(procurement.delivery_date).toLocaleDateString() 
                : 'Not delivered yet'}
            </p>
          </div>
        </div>
      </div>
      
      {/* Transport and shipping details */}
      <div className={isMobile ? "grid grid-cols-1 gap-4" : "grid grid-cols-1 md:grid-cols-2 gap-4"}>
        <div className="p-4 border rounded-md">
          <h3 className="text-sm font-medium mb-2">Transport Details</h3>
          <p>Cost: Br {procurement.transport_cost_per_unit?.toFixed(2) || '0.00'}/kg</p>
          <p>Total: Br {((procurement.transport_cost_per_unit || 0) * (procurement.total_quantity || 0)).toFixed(2)}</p>
        </div>
        
        <div className="p-4 border rounded-md">
          <h3 className="text-sm font-medium mb-2">Loading/Unloading</h3>
          <p>Cost: Br {procurement.loading_unloading_cost_per_unit?.toFixed(2) || '0.00'}/kg</p>
          <p>Total: Br {((procurement.loading_unloading_cost_per_unit || 0) * (procurement.total_quantity || 0)).toFixed(2)}</p>
        </div>
      </div>
    </div>
  );
}
